import { useStoreData } from '../contexts/StoreDataContext';

const ADMIN_NAV_PERMISSIONS = [
  'MANAGE_STORE_USERS',
  'MANAGE_ROLES',
  'MANAGE_STORE',
  'VIEW_STORE_LOGS'
];

/** Accès nav (header / barre mobile) : prêt seulement quand les droits sont connus. */
export function useAppNavAccess() {
  const {
    hasPermission,
    hasAnyPermission,
    isAdmin,
    permissionsLoading,
    hasAnyCommission
  } = useStoreData();

  const ready = !permissionsLoading;
  const canCentre = ready && hasPermission('CENTRE_ACCESS');
  const canCommissions =
    ready &&
    (hasPermission('VIEW_COMMISSIONS') || hasPermission('MANAGE_COMMISSIONS')) &&
    hasAnyCommission === true;
  const canAdmin = ready && (hasAnyPermission(ADMIN_NAV_PERMISSIONS) || isAdmin());
  const canSearchOrders =
    ready && hasAnyPermission(['SEARCH_ALL_ORDERS', 'SEARCH_OWN_ORDERS']);

  return {
    ready,
    canCentre,
    canCommissions,
    canAdmin,
    canSearchOrders
  };
}
